import axios from 'axios';
import * as biz from './biz';
import * as utils from './utils';
import {EventBus} from "../components/AudioPlayerNew";

const VISIBLE_SPINNER = process.env.VISIBLE_SPINNER;

function getHeader(ref) {
    axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URI;

    if (typeof ref.$cookie.get("accessToken") !== "undefined") {
        if (ref.$cookie.get("accessToken") !== null) {
            axios.defaults.headers.common['Authorization'] = ref.$cookie.get("accessToken");
        }
    }

    return axios;
}

export function Get(ref, url, callback, visibleSpinner = VISIBLE_SPINNER, param) {
    if (visibleSpinner)
        ref.$store.commit('setLoading', true)

    const http = getHeader(ref);
    http.get(url, param)
        .then((response) => {
            successProcess(ref, response, callback)

        }).catch((error) => {
            failProcess(error);

        }).then(() => {
            if (visibleSpinner)
                ref.$store.commit('setLoading', false);
        })
}

export function Post(ref, url, param, callback, visibleSpinner = VISIBLE_SPINNER) {
    if (visibleSpinner)
        ref.$store.commit('setLoading', true)

    const http = getHeader(ref);
    http.post(url, param)
        .then((response) => {
            successProcess(ref, response, callback)

        }).catch((error) => {
            failProcess(error);

        }).then(() => {
            if (visibleSpinner)
                ref.$store.commit('setLoading', false);
        })
}

export function Put(ref, url, param, callback, visibleSpinner = VISIBLE_SPINNER) {
    if (visibleSpinner)
        ref.$store.commit('setLoading', true)

    const http = getHeader(ref);
    http.put(url, param)
        .then((response) => {
            successProcess(ref, response, callback)

        }).catch((error) => {
            failProcess(error);

        }).then(() => {
            if (visibleSpinner)
                ref.$store.commit('setLoading', false);
        })
}

export function Delete(ref, url, callback, visibleSpinner = VISIBLE_SPINNER) {
    if (visibleSpinner)
        ref.$store.commit('setLoading', true)

    const http = getHeader(ref);
    http.delete(url)
        .then((response) => {
            successProcess(ref, response, callback)

        }).catch((error) => {
        failProcess(error);

    }).then(() => {
        if (visibleSpinner)
            ref.$store.commit('setLoading', false);
    })
}

function successProcess(ref, response, callback) {
    const responseData = response.data;

    if (!utils.isEmpty(responseData)) {
        switch (responseData.code) {
            case "0000":
            case "6000":
                if (callback !== null)
                    callback(ref, responseData.message);
                break;

            case "2000":
                document.querySelector('ion-alert-controller').create({
                    message: responseData.message,
                    buttons: ['확인']
                }).then(alert => {
                    alert.present();
                });

                break;

            case "5000":
                // 인증실패에 관한 프로세스
                ref.$cookie.delete("accessToken");
                ref.$router.push("/login");
                EventBus.$emit('stopMiniPlayer');

                break;

            // case "6000":
            //     if (callback !== null)
            //         callback(ref, responseData.message);
            //     // 플레이어 재생권한 없음
            //     // Login 여부 체크
            //     if (biz.isLogin(ref)) {
            //         document.querySelector('ion-alert-controller').create({
            //             message: "이 강의는 사용 중인 이용권이 있어야 들을 수 있습니다.\n<b>언제든지 해지 가능</b>한 듣는교과서의 <b>이용권</b>으로\n다양한 강의들을 <b>부담없는 가격</b>으로 만나보세요!",
            //             buttons: [
            //                 {
            //                     text: 'Will do it next time',
            //                     role: 'cancel',
            //                     cssClass: 'secondary',
            //                     handler: () => {
            //                         // console.log('Confirm Cancel');
            //                     },
            //                 },
            //                 {
            //                     text: 'Go to the type of pass',
            //                     handler: () => {
            //                         window.location = "/mypage/ticket";
            //                     },
            //                 },
            //             ],
            //             mode: "ios"
            //         }).then(alert => {
            //             alert.present();
            //         });
            //     } else {
            //         document.querySelector('ion-alert-controller').create({
            //             message: "이 강의는 사용 중인 이용권이 있어야 들을 수 있습니다.\n더 많은 강의를 들어보고 싶으시다구요?\n<b>\n지금 가입하고 듣는교과서를 즐겨보세요!\n듣는교과서 회원이신가요? <a href='/login'>Login하기</a>",
            //             buttons: [
            //                 {
            //                     text: 'Will do it next time',
            //                     role: 'cancel',
            //                     cssClass: 'secondary',
            //                     handler: () => {
            //                         // console.log('Confirm Cancel');
            //                     },
            //                 },
            //                 {
            //                     text: '회원가입하러 가기',
            //                     handler: () => {
            //                         window.location = "/member/join/step2";
            //                     },
            //                 },
            //             ],
            //             mode: "ios"
            //         }).then(alert => {
            //             alert.present();
            //         });
            //     }
            //     break;

            default:
                break
        }

    }
}

function failProcess(error) {
    console.log(error);
}
